module.exports = __webpack_public_path__ + "img/regulations-leisure-2.bac4840f.jpg";